import ContributionAmount from '@/components/widget/contribution/ContributionAmount.vue';
import WidgetCreatePassword from '@/components/widget/create-password/CreatePassword.vue';
import EnterEmail from '@/components/widget/enter-email/EnterEmail.vue';
import WidgetForgotPassword from '@/components/widget/forgot-password/WidgetForgotPassword.vue';
import LaybyConfiguration from '@/components/widget/order-configuration/LaybyConfiguration.vue';
import WidgetOtpVerification from '@/components/widget/otp-verification/WidgetOtpVerification.vue';
import DebiCheck from '@/components/widget/payment/DebiCheck.vue';
import PayAt from '@/components/widget/payment/PayAt.vue';
import PeachPayment from '@/components/widget/payment/PeachPayment.vue';
import SelectPaymentMethod from '@/components/widget/payment/SelectPaymentMethod.vue';
import PaymentPlanBreakdown from '@/components/widget/payments-breakdown/PaymentsBreakdown.vue';
import WidgetSignIn from '@/components/widget/sign-in/WidgetSignIn.vue';
import WidgetSignUp from '@/components/widget/sign-up/WidgetSignUp.vue';
import {
  fixStateRedirectGuard,
  initializeWidgetOrderGuard,
  selectPaymentMethodGuard,
} from '@/utils/order-widget.utils';
import OrderWidget from '@/views/OrderWidget.vue';
import type { RouteRecordRaw } from 'vue-router';
import HowItWorks from '../components/widget/how-it-works/BoostHowItWorks.vue';
import BoostConfiguration from '../components/widget/order-configuration/BoostConfiguration.vue';
import BoostPaymentBreakdown from '../components/widget/payments-breakdown/BoostPaymentsBreakdown.vue';
import { authGuard } from '../utils/auth.utils';

// Ideally we should add /widget/ to these routes as there is going to be overlap with /shopper/ routes but for now we will leave it as is to avoid breaking changes.
export const widgetRoutes: RouteRecordRaw = {
  path: '',
  children: [
    {
      path: 'payment-plan/:id',
      component: OrderWidget,
      beforeEnter: initializeWidgetOrderGuard,
      props: true,
      children: [
        {
          path: '',
          name: 'LayByConfiguration',
          component: LaybyConfiguration,
        },
        { path: 'breakdown', name: 'PaymentPlanBreakdown', component: PaymentPlanBreakdown },
        { path: 'sign-in', name: 'WidgetSignIn', component: WidgetSignIn, beforeEnter: authGuard },
        { path: 'sign-up', name: 'WidgetSignUp', component: WidgetSignUp },
        { path: 'forgot-password', name: 'WidgetForgotPassword', component: WidgetForgotPassword },
        {
          path: 'otp-verification',
          name: 'OtpVerification',
          component: WidgetOtpVerification,
        },
        {
          path: 'create-password',
          name: 'CreatePassword',
          component: WidgetCreatePassword,
          meta: { requiresAuth: true },
        },
        {
          path: 'peach-payment',
          beforeEnter: fixStateRedirectGuard,
          name: 'PeachPayment',
          component: PeachPayment,
          meta: { requiresAuth: true },
        },
        {
          path: 'contribute',
          name: 'Contribute',
          component: ContributionAmount,
          meta: { requiresAuth: true },
        },
        {
          path: 'paymentMethod',
          beforeEnter: [fixStateRedirectGuard, selectPaymentMethodGuard],
          name: 'SelectPaymentMethod',
          component: SelectPaymentMethod,
          meta: { requiresAuth: true },
        },
        {
          path: 'pay-at',
          beforeEnter: fixStateRedirectGuard,
          name: 'PayAt',
          component: PayAt,
          meta: { requiresAuth: true },
        },
        {
          path: 'debi-check',
          name: 'DebiCheck',
          component: DebiCheck,
          meta: { requiresAuth: true },
        },
      ],
    },
    {
      path: 'boost/:id',
      component: OrderWidget,
      props: true,
      children: [
        {
          path: '',
          name: 'SavingsPlanHowItWorks',
          component: HowItWorks,
          meta: { showProgress: false },
        },
        {
          path: 'configuration',
          children: [
            {
              path: '',
              name: 'BoostConfiguration',
              component: BoostConfiguration,
            },
            { path: 'breakdown', name: 'BoostPaymentBreakdown', component: BoostPaymentBreakdown },
          ],
        },
        { path: 'enter-email', name: 'EnterEmail', component: EnterEmail, meta: { requiresAuth: true } },
      ],
    },
  ],
};
